import RolesSection from '../components/RolesSection';

const FeaturesPage = ({ onOpenSignup }) => <RolesSection onOpenSignup={onOpenSignup} />;

export default FeaturesPage;